import React from 'react';
import { ScrollMenu,
    // VisibilityContext
} from "react-horizontal-scrolling-menu";
import "./hideScrollbar.css";
import { HorizontalScrollCard } from './HorizontalScrollCard';
import useDrag from './useDrag';


// import data from a json file
// const tutors = require('../HorizontalCards/tutorsData.json');
const tutors = require('../HorizontalCards/tutors.json');



const HorizontalScroll = () => {
  // const [items] = React.useState(getItems);


  // const { dragStart, dragStop, dragMove, dragging } = useDrag();
  const { dragStart, dragStop, dragMove } = useDrag();
  const handleDrag = ({ scrollContainer }) => (
    ev
  ) => {
    dragMove(ev, (posDiff) => {
      if (scrollContainer.current) {
        scrollContainer.current.scrollLeft += posDiff;
      }
    })
  };
    // const [selected, setSelected] = "";



  const tutorList = tutors.results

  // make an array of tutors from each objects in the json file
  // const tutorArray = Object.values(tutorList);
  

  
 console.log(tutors);
  // const handleItemClick = () => () => {
  //   if (dragging) {
  //     return false;
  //   }
  //   // Link.push(`/cards/${cards.id}`);
  // };

  return (
    <>
        <div onMouseLeave={dragStop} >
          <ScrollMenu
            // LeftArrow={LeftArrow}
            // RightArrow={RightArrow}
            // onWheel={onWheel}
            itemClassName ={"slider-item"}
            onMouseDown={() => dragStart}
            onMouseUp={() => dragStop}
            onMouseMove={handleDrag}
          >

           {/* display the cards according to TutorList */}
           {/* map 10  cards according to TutorList  */}




            {tutorList.slice(0, 10).map((results, index) => (
             
                // console.log(results.name.first)
              <HorizontalScrollCard
                // name={results.name.first}
                // itemId={results.id} // NOTE: itemId is required for track items
                // key={index}
                // image={results.picture.thumbnail}
                data={results}
                list={results.list}
                // shape='square'
                // onClick={handleItemClick(results.id)}
                // selected={results.id === selected}
              />
            
            ))} 
          </ScrollMenu>
        </div>
      {/* </ShopListWrapper> */}
    </>
  );
};

export default HorizontalScroll;
